import { NavLink, Outlet, useLocation } from "react-router-dom";
import { ShieldCheck, AlertTriangle, Users, FileWarning, ScrollText, FileEdit, Sliders, LayoutDashboard, BookOpen } from "lucide-react";
import { cn } from "@/lib/utils";

const items = [
  { to: "/partner/compliance", end: true, label: "Dashboard", icon: LayoutDashboard },
  { to: "/partner/compliance/breaches", label: "Breach Register (§16)", icon: AlertTriangle },
  { to: "/partner/compliance/governance", label: "Governance (§14)", icon: Users },
  { to: "/partner/compliance/conflicts", label: "Conflicts (§15)", icon: FileWarning },
  { to: "/partner/compliance/mi", label: "MI / Disclosure (§17)", icon: ScrollText },
  { to: "/partner/compliance/amendments", label: "Amendment Log (§18)", icon: FileEdit },
  { to: "/partner/compliance/thresholds", label: "Policy Thresholds", icon: Sliders },
  { to: "/partner/compliance/threshold-provenance", label: "Threshold Provenance", icon: BookOpen },
];

export default function ComplianceLayout() {
  const { pathname } = useLocation();
  return (
    <div className="container mx-auto px-4 py-6 max-w-7xl">
      <div className="flex items-center gap-3 mb-6">
        <ShieldCheck className="h-7 w-7 text-primary" />
        <div>
          <h1 className="text-2xl font-bold">Compliance</h1>
          <p className="text-sm text-muted-foreground">Tier 1 §14–§18 governance, breach and policy oversight</p>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-6">
        <aside className="col-span-12 md:col-span-3">
          <nav className="space-y-1">
            {items.map((it) => {
              const active = it.end ? pathname === it.to : pathname.startsWith(it.to);
              return (
                <NavLink
                  key={it.to}
                  to={it.to}
                  end={it.end}
                  className={cn(
                    "flex items-center gap-2 px-3 py-2 text-sm rounded-md transition-colors",
                    active ? "bg-primary text-primary-foreground font-medium" : "text-muted-foreground hover:text-foreground hover:bg-muted"
                  )}
                >
                  <it.icon className="h-4 w-4" />
                  {it.label}
                </NavLink>
              );
            })}
          </nav>
        </aside>
        <main className="col-span-12 md:col-span-9">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
